const POMLCKA = "—";

const PROFILY = Object.freeze({
  konzervativny: "Konzervatívny",
  vyvazeny: "Vyvážený",
  dynamicky: "Dynamický",
});

const FORMAT_SUMY = new Intl.NumberFormat("sk-SK", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const FORMAT_PERCENTA = new Intl.NumberFormat("sk-SK", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

function cisloAleboNull(hodnota) {
  const cislo = Number(hodnota);

  return Number.isFinite(cislo)
    ? cislo
    : null;
}

function kladneCisloAleboNull(hodnota) {
  const cislo = cisloAleboNull(hodnota);

  return cislo !== null && cislo > 0
    ? cislo
    : null;
}

function formatujSumu(
  hodnota,
  ibaKladna = false
) {
  const cislo = ibaKladna
    ? kladneCisloAleboNull(hodnota)
    : cisloAleboNull(hodnota);

  return cislo === null
    ? null
    : `${FORMAT_SUMY.format(cislo)} €`;
}

function formatujPercento(
  hodnota,
  suffix = ""
) {
  const cislo = cisloAleboNull(hodnota);

  return cislo === null
    ? null
    : `${FORMAT_PERCENTA.format(cislo)} %${suffix}`;
}

function formatujKladnePercento(
  hodnota,
  suffix = ""
) {
  const cislo =
    kladneCisloAleboNull(hodnota);

  return cislo === null
    ? null
    : `${FORMAT_PERCENTA.format(cislo)} %${suffix}`;
}

function formatujRoky(
  hodnota,
  ibaKladne = false
) {
  const cislo = ibaKladne
    ? kladneCisloAleboNull(hodnota)
    : cisloAleboNull(hodnota);

  return cislo === null
    ? null
    : `${FORMAT_SUMY.format(cislo)} r.`;
}

function formatujNasobok(hodnota) {
  const cislo = cisloAleboNull(hodnota);

  return cislo === null
    ? null
    : `${FORMAT_PERCENTA.format(cislo)}×`;
}

function formatujProfil(hodnota) {
  const kluc = String(
    hodnota || ""
  ).trim();

  return PROFILY[kluc] || null;
}

function vytvorRiadok(
  label,
  hodnoty,
  moznosti = {}
) {
  if (
    !hodnoty.some(
      (hodnota) => hodnota !== null
    )
  ) {
    return null;
  }

  return {
    label,
    hodnoty: hodnoty.map(
      (hodnota) => hodnota ?? POMLCKA
    ),
    odsadenie: Boolean(
      moznosti.odsadenie
    ),
  };
}

function vytvorSekciu(
  kluc,
  nazov,
  riadky
) {
  const platneRiadky =
    riadky.filter(Boolean);

  return platneRiadky.length
    ? {
        kluc,
        nazov,
        riadky: platneRiadky,
      }
    : null;
}

function jeDanZapnuta(nastavenia) {
  return (
    nastavenia?.danovyRezim ===
      "zdanit" &&
    Number(
      nastavenia?.sadzbaDane
    ) > 0
  );
}

function formatujTypPoplatku(
  nastavenia
) {
  if (
    nastavenia?.typPoplatku ===
      "jednorazovy" &&
    Number(
      nastavenia?.jednorazovyPoplatok
    ) > 0
  ) {
    return `Jednorazový: ${formatujSumu(
      nastavenia.jednorazovyPoplatok,
      true
    )}`;
  }

  if (
    nastavenia?.typPoplatku ===
      "priebežny" &&
    Number(
      nastavenia
        ?.priebeznyPoplatokPercento
    ) > 0
  ) {
    return `Priebežný: ${formatujKladnePercento(
      nastavenia
        .priebeznyPoplatokPercento
    )}`;
  }

  if (
    nastavenia?.typPoplatku ===
      "rozlozeny" &&
    Number(
      nastavenia
        ?.rozlozenyPoplatokPercento
    ) > 0
  ) {
    return `Rozložený: ${formatujKladnePercento(
      nastavenia
        .rozlozenyPoplatokPercento
    )} z CS`;
  }

  return null;
}

function vypocitajNastavenieRozlozenehoPoplatku(
  nastavenia
) {
  if (
    nastavenia?.typPoplatku !==
    "rozlozeny"
  ) {
    return null;
  }

  const cielovaSuma =
    kladneCisloAleboNull(
      nastavenia?.cielovaSuma
    );

  const mesacnyVklad =
    kladneCisloAleboNull(
      nastavenia?.mesacnyVklad
    );

  const percentoZCielovejSumy =
    kladneCisloAleboNull(
      nastavenia
        ?.rozlozenyPoplatokPercento
    );

  const maxPercentoZVkladu =
    kladneCisloAleboNull(
      nastavenia
        ?.maxRozlozenyPoplatokZVkladuPercento
    );

  if (
    cielovaSuma === null ||
    mesacnyVklad === null ||
    percentoZCielovejSumy === null ||
    maxPercentoZVkladu === null
  ) {
    return null;
  }

  const poplatokCelkom =
    cielovaSuma *
    (
      percentoZCielovejSumy /
      100
    );

  const maxZoSplatky =
    mesacnyVklad *
    (
      maxPercentoZVkladu /
      100
    );

  return {
    pocetSplatok: Math.ceil(
      poplatokCelkom /
        maxZoSplatky
    ),
    maxPercentoZVkladu,
  };
}

function formatujPocetSplatokPoplatku(
  nastavenia
) {
  const nastavenie =
    vypocitajNastavenieRozlozenehoPoplatku(
      nastavenia
    );

  return nastavenie
    ? String(
        nastavenie.pocetSplatok
      )
    : null;
}

function formatujMaxPercentoZVkladu(
  nastavenia
) {
  const nastavenie =
    vypocitajNastavenieRozlozenehoPoplatku(
      nastavenia
    );

  return nastavenie
    ? formatujKladnePercento(
        nastavenie.maxPercentoZVkladu
      )
    : null;
}

function formatujPrivklad(
  nastavenia
) {
  if (
    !nastavenia
      ?.jednorazovyPrivkladZapnuty ||
    Number(
      nastavenia
        ?.jednorazovyPrivklad
    ) <= 0 ||
    Number(
      nastavenia
        ?.jednorazovyPrivkladMesiac
    ) <= 0
  ) {
    return null;
  }

  return `${formatujSumu(
    nastavenia
      .jednorazovyPrivklad,
    true
  )} | v mesiaci č. ${Math.floor(
    Number(
      nastavenia
        .jednorazovyPrivkladMesiac
    )
  )}`;
}

function formatujNavysovanie(
  nastavenia
) {
  if (
    Number(
      nastavenia?.mesacnyVklad
    ) <= 0 ||
    nastavenia
      ?.rezimNavysovaniaVkladu ===
      "ziadne"
  ) {
    return null;
  }

  if (
    nastavenia
      ?.rezimNavysovaniaVkladu ===
      "inflacia" &&
    Number(
      nastavenia?.inflacia
    ) > 0
  ) {
    return `infláciu ${formatujKladnePercento(
      nastavenia.inflacia,
      " p.a."
    )}`;
  }

  if (
    nastavenia
      ?.rezimNavysovaniaVkladu ===
      "fix" &&
    Number(
      nastavenia
        ?.fixneNavysenieVkladu
    ) > 0
  ) {
    return `fixnú sumu ${formatujSumu(
      nastavenia
        .fixneNavysenieVkladu,
      true
    )}`;
  }

  return null;
}

function maNavysovanie(
  nastavenia
) {
  return (
    formatujNavysovanie(
      nastavenia
    ) !== null
  );
}

function maDodatocneZhodnocovanie(
  nastavenia
) {
  return (
    Boolean(
      nastavenia
        ?.dodatocneZhodnocovanieZapnute
    ) &&
    Number(
      nastavenia
        ?.dodatocneZhodnocovanieRoky
    ) > 0
  );
}

function maInflaciu(nastavenia) {
  return (
    Number(
      nastavenia?.inflacia
    ) > 0
  );
}

function maVypocitanePoplatky(
  variant
) {
  return (
    Number(
      variant?.vysledok
        ?.celkovePoplatky
    ) > 0
  );
}

export function vytvorInvestPdfPrehlad({
  porovnanieInvesticii,
  variant1,
  variant2,
  vysledkyInvesticii,
  sekcie,
}) {
  const varianty = [
    {
      kluc: "variant1",
      label: "Variant 1",
      nastavenia:
        variant1 || {},
      vysledok:
        vysledkyInvesticii
          ?.variant1 || {},
    },
  ];

  if (porovnanieInvesticii) {
    varianty.push({
      kluc: "variant2",
      label: "Variant 2",
      nastavenia:
        variant2 || {},
      vysledok:
        vysledkyInvesticii
          ?.variant2 || {},
    });
  }

  const hodnoty =
    (ziskajHodnotu) =>
      varianty.map(
        (variant) =>
          ziskajHodnotu(variant)
      );

  const maAspoJednuDan =
    sekcie?.zahrnutPoplatky &&
    varianty.some(
      (variant) =>
        jeDanZapnuta(
          variant.nastavenia
        )
    );

  const maAspoJednyVypocitanePoplatky =
    sekcie?.zahrnutPoplatky &&
    varianty.some(
      maVypocitanePoplatky
    );

  const prehladSekcie = [
    vytvorSekciu(
        "vstupneParametre",
        "Vstupné parametre investície:",
        [
        vytvorRiadok(
            "Profil:",
            hodnoty(
            (variant) =>
                formatujProfil(
                variant.nastavenia
                    .investicnyProfil
                )
            )
        ),
        vytvorRiadok(
            "Jednorazovo:",
            hodnoty(
            (variant) =>
                formatujSumu(
                variant.nastavenia
                    .jednorazovyVklad,
                true
                )
            )
        ),
        vytvorRiadok(
            "Mesačne:",
            hodnoty(
            (variant) =>
                formatujSumu(
                variant.nastavenia
                    .mesacnyVklad,
                true
                )
            )
        ),
        vytvorRiadok(
            "Cieľová suma:",
            hodnoty(
            (variant) =>
                formatujSumu(
                variant.nastavenia
                    .cielovaSuma,
                true
                )
            )
        ),
        ]
    ),

    vytvorSekciu(
        "vystupInvesticie",
        "Výstup investície:",
        [
        vytvorRiadok(
            "Priemerné ročné zhodnotenie:",
            hodnoty(
            (variant) =>
                formatujPercento(
                variant.vysledok
                    .zhodnotenie ??
                    variant.nastavenia
                    .zhodnotenie,
                " p.a."
                )
            )
        ),
        vytvorRiadok(
            "Celkový investičný horizont:",
            hodnoty(
            (variant) =>
                formatujRoky(
                variant.vysledok
                    .celkovaDobaInvesticieRoky ??
                    variant.nastavenia
                    .horizont
                )
            )
        ),
        vytvorRiadok(
            "Celková hodnota investície:",
            hodnoty(
            (variant) =>
                formatujSumu(
                variant.vysledok
                    .konecnaHodnota
                )
            )
        ),
        vytvorRiadok(
            "z toho celkové vklady:",
            hodnoty(
            (variant) =>
                formatujSumu(
                variant.vysledok
                    .celkoveVklady
                )
            ),
            {
            odsadenie: true,
            }
        ),
        maAspoJednuDan
            ? vytvorRiadok(
                "z toho daň:",
                hodnoty(
                (variant) =>
                    formatujSumu(
                    jeDanZapnuta(
                        variant.nastavenia
                    )
                        ? variant.vysledok
                            .danZVynosu
                        : 0
                    )
                ),
                {
                odsadenie: true,
                }
            )
            : null,
        vytvorRiadok(
            "z toho čistý výnos:",
            hodnoty(
            (variant) =>
                formatujSumu(
                variant.vysledok
                    .celkovyVynos
                )
            ),
            {
            odsadenie: true,
            }
        ),
        ]
    ),

    sekcie?.zahrnutRozsirenyVystup
        ? vytvorSekciu(
            "rozsirenyVystupInvesticie",
            "Rozšírený výstup investície:",
            [
            vytvorRiadok(
                "Jednorazový prívklad:",
                hodnoty(
                (variant) =>
                    formatujPrivklad(
                    variant.nastavenia
                    )
                )
            ),
            vytvorRiadok(
                "Priemerná ročná inflácia:",
                hodnoty(
                (variant) =>
                    maInflaciu(
                    variant.nastavenia
                    )
                    ? formatujKladnePercento(
                        variant.nastavenia
                            .inflacia,
                        " p.a."
                        )
                    : null
                )
            ),
            vytvorRiadok(
                "Reálna hodnota po inflácii:",
                hodnoty(
                (variant) =>
                    maInflaciu(
                    variant.nastavenia
                    )
                    ? formatujSumu(
                        variant.vysledok
                            .realnaHodnotaPoInflacii
                        )
                    : null
                )
            ),
            vytvorRiadok(
                "Celkové zhodnotenie po inflácii:",
                hodnoty(
                (variant) =>
                    maInflaciu(
                    variant.nastavenia
                    )
                    ? formatujPercento(
                        variant.vysledok
                            .realneZhodnoteniePoInflaciiPercento
                        )
                    : null
                )
            ),
            vytvorRiadok(
                "Každoročné navýšenie vkladov o:",
                hodnoty(
                (variant) =>
                    formatujNavysovanie(
                    variant.nastavenia
                    )
                )
            ),
            vytvorRiadok(
                "Prínos navýšenia vkladov:",
                hodnoty(
                (variant) =>
                    maNavysovanie(
                    variant.nastavenia
                    ) &&
                    Number(
                    variant.vysledok
                        .prinosNavyseniaVkladov
                    ) > 0
                    ? formatujSumu(
                        variant.vysledok
                            .prinosNavyseniaVkladov
                        )
                    : null
                )
            ),
            vytvorRiadok(
                "Dodatočné zhodnocovanie:",
                hodnoty(
                (variant) =>
                    maDodatocneZhodnocovanie(
                    variant.nastavenia
                    )
                    ? formatujRoky(
                        variant.nastavenia
                            .dodatocneZhodnocovanieRoky,
                        true
                        )
                    : null
                )
            ),
            vytvorRiadok(
                "Prínos dodatočného zhodnotenia:",
                hodnoty(
                (variant) =>
                    maDodatocneZhodnocovanie(
                    variant.nastavenia
                    ) &&
                    Number(
                    variant.vysledok
                        .prinosDodatocnehoZhodnotenia
                    ) > 0
                    ? formatujSumu(
                        variant.vysledok
                            .prinosDodatocnehoZhodnotenia
                        )
                    : null
                )
            ),
            vytvorRiadok(
                "Celkové zhodnotenie vkladu (ROI):",
                hodnoty(
                (variant) =>
                    formatujPercento(
                    variant.vysledok
                        .celkoveZhodnotenieVkladuPercento ??
                        variant.vysledok
                        .roiPercento
                    )
                )
            ),
            vytvorRiadok(
                "Násobok vkladov:",
                hodnoty(
                (variant) =>
                    formatujNasobok(
                    variant.vysledok
                        .nasobokVkladov
                    )
                )
            ),
            maAspoJednyVypocitanePoplatky
                ? vytvorRiadok(
                    "Celkové poplatky:",
                    hodnoty(
                    (variant) =>
                        formatujSumu(
                        variant.vysledok
                            .celkovePoplatky ??
                            0
                        )
                    )
                )
                : null,
            maAspoJednyVypocitanePoplatky
                ? vytvorRiadok(
                    "Efekt poplatkov:",
                    hodnoty(
                    (variant) =>
                        formatujPercento(
                        variant.vysledok
                            .efektPoplatkovPercento ??
                            0
                        )
                    )
                )
                : null,
            ]
        )
        : null,

    sekcie?.zahrnutPoplatky
        ? vytvorSekciu(
            "nastaveniaPoplatkov",
            "Nastavenia poplatkov:",
            [
            vytvorRiadok(
                "Typ poplatku:",
                hodnoty(
                (variant) =>
                    formatujTypPoplatku(
                    variant.nastavenia
                    )
                )
            ),
            vytvorRiadok(
                "Počet splátok:",
                hodnoty(
                (variant) =>
                    formatujPocetSplatokPoplatku(
                    variant.nastavenia
                    )
                )
            ),
            vytvorRiadok(
                "Max. z vkladu:",
                hodnoty(
                (variant) =>
                    formatujMaxPercentoZVkladu(
                    variant.nastavenia
                    )
                )
            ),
            vytvorRiadok(
                "Manažérsky poplatok:",
                hodnoty(
                (variant) =>
                    formatujKladnePercento(
                    variant.nastavenia
                        .manazerskyPoplatok,
                    " p.a."
                    )
                )
            ),
            vytvorRiadok(
                "Daň:",
                hodnoty(
                (variant) =>
                    jeDanZapnuta(
                    variant.nastavenia
                    )
                    ? formatujKladnePercento(
                        variant.nastavenia
                            .sadzbaDane
                        )
                    : null
                )
            ),
            ]
        )
        : null,
    ].filter(Boolean);

  return {
    varianty: varianty.map(
      ({
        kluc,
        label,
      }) => ({
        kluc,
        label,
      })
    ),
    sekcie: prehladSekcie,
  };
}